import React from 'react';
import PropTypes from 'prop-types';

const SystemLogsTable = ({ items }) => (
    <table className="systemlog">
        <tbody>
            {items.map(item => (
                <tr className="systemlog-row" key={`systemlog_${item.id}`}>
                    <td className="systemlog-row-id">{item.id}</td>
                    <td className="systemlog-row-time">{item.create_timestamp}</td>
                    <td className="systemlog-row-text">{item.text}</td>
                </tr>
            ))}
        </tbody>
    </table>
);

SystemLogsTable.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            create_timestamp: PropTypes.string,
            text: PropTypes.string,
        }),
    ),
};

export default React.memo(SystemLogsTable);



// WEBPACK FOOTER //
// ./source/components/systemLogs/systemLogsTable.js